import CookieHelper from '@core/scripts/helper/cookie.js';
import JSONParser from '@core/scripts/helper/json-parser.js';

const cookieExpiration = 600000;

function nonEmpty(element) {
    return element.trim() !== '';
}

function handleEntryStylesProductSlider(config) {
    config = JSONParser.tryParseJSON(config) || config;
    if (!config.slider) {
        return;
    }
    const sliderConfig = config.slider;

    if (sliderConfig.type !== 'shop' && sliderConfig.type !== 'order_item') {
        return;
    }

    const cookieName = 'teaserEntrySlider';
    const newEntryType = sliderConfig.type;
    const newReferencedArticle = sliderConfig.reference;
    const newHeadline = sliderConfig.headline;
    const newLinkTarget = sliderConfig.target;

    const oldCookie = CookieHelper.get(cookieName) || '';

    const newCookie = oldCookie
        .split('|')
        .filter(nonEmpty)
        .map((entry) => {
            return entry.split(':');
        })
        .filter((entry) => {
            // Filter out the same entry
            const [entryType, linkTarget, referencedArticle] = entry;
            return (
                entryType !== newEntryType && linkTarget !== newLinkTarget && referencedArticle !== newReferencedArticle
            );
        })
        // append the new one
        .concat([[newEntryType, newLinkTarget, newReferencedArticle, newHeadline]])
        .map((entry) => {
            return entry.join(':');
        })
        .join('|')
        .concat('|'); // Monolith Implementierung benötigt dies am Ende

    CookieHelper.set(cookieName, newCookie, {
        expires: cookieExpiration,
    });
}

function handleEntryStylesRecommendation(config) {
    config = JSONParser.tryParseJSON(config) || config;

    if (!config.ranking) {
        return;
    }
    const rankingConfig = config.ranking;

    const cookieName = 'entrystyles_';
    const newShopId = rankingConfig.shopId;
    const newListOfStyleIds = rankingConfig.styleIds;

    const oldCookie = CookieHelper.get(cookieName) || '';

    const newCookie = oldCookie
        .split(';')
        .filter(nonEmpty)
        .map((entry) => {
            return entry.split(':');
        })
        .filter((entry) => {
            // Filter out the entry with the same shop id
            const shopId = entry[0];
            return shopId !== newShopId;
        })
        // append the new one
        .concat([[newShopId, newListOfStyleIds.join(',')]])
        .map((entry) => {
            return entry.join(':');
        })
        .join(';')
        .concat(';');

    if (window.hc_consent?.getCategoriesConsents()?.PERSONALIZATION === 1) {
        CookieHelper.set(cookieName, newCookie, {
            expires: cookieExpiration,
        });
    }
}

export {handleEntryStylesProductSlider, handleEntryStylesRecommendation};
